export const GET_BLOGS = 'GET_BLOGS';
export const GET_BLOGS_SUCCESS = 'GET_BLOGS_SUCCESS';
export const GET_BLOGS_FAILURE = 'GET_BLOGS_FAILURE';

export const GET_BLOG = 'GET_BLOG';
export const GET_BLOG_SUCCESS = 'GET_BLOG_SUCCESS';
export const GET_BLOG_FAILURE = 'GET_BLOG_FAILURE';

export const GET_RELATED_BLOGS = 'GET_RELATED_BLOGS';
export const GET_RELATED_BLOGS_SUCCESS = 'GET_RELATED_BLOGS_SUCCESS';
export const GET_RELATED_BLOGS_FAILURE = 'GET_RELATED_BLOGS_FAILURE';

export const CLEAR_CURRENT_BLOG = 'CLEAR_CURRENT_BLOG';
